import { getSyncDefaultSearch } from '../../helpers/Common';
import reducerRegistry from './../../helpers/ReducerRegistry';
import TimeAndSaleService from '../../../core/services/Prices/TimeAndSale/TimeAndSaleService';
import priceDataService from './../../../core/services/Prices/PriceData/PriceDataService';
import ConstCommon from '../../common/Const';
import currentState from './../../helpers/CurrentState';

const REDUCER_NAME = 'TIME_AND_SALE:';
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const FETCH_DATA_TIME_AND_SALE = `${REDUCER_NAME}FETCH_DATA_TIME_AND_SALE`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const CHANGE_CODE = `${REDUCER_NAME}CHANGE_CODE`;
const GET_TOP_CONTENT = `${REDUCER_NAME}GET_TOP_CONTENT`;
const SUBSCRIBE_REALTIME_DATA = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA`;
const RESET_REALTIME_DATA = `${REDUCER_NAME}RESET_REALTIME_DATA`;
const SET_FETCHING = `${REDUCER_NAME}SET_FETCHING`;
const FETCH_DATA_STAT_CHART = `${REDUCER_NAME}FETCH_DATA_STAT_CHART`;
const FETCH_BUSD_SUCCESS = `${REDUCER_NAME}FETCH_BUSD_SUCCESS`;

export {
  REDUCER_NAME,
  reducer as default,
  fetchDataTimeAndSale,
  changeCode,
  fetchInfoTicker,
  subscribeRealtime,
  fetchStatChartData,
  fetchBusd,
};

function fetchBusd(params, componentId) {
  return function(dispatch) {
    TimeAndSaleService.getBuSdChart(params).then(res => {
      dispatch({
        type: FETCH_BUSD_SUCCESS,
        payload: {
          componentId,
          data: res.items || [],
        },
      });
    });
  };
}

function setFetching(status = true, id) {
  return {
    type: SET_FETCHING,
    payload: {
      status,
      id,
    },
  };
}

function subscribeRealtime(data, id, keyCode) {
  return (dispatch, getState) => {
    const code = getState()[REDUCER_NAME].listMultiComponent[id].condition.code;
    const result = data.find(item => item[keyCode] === code);
    dispatch({
      type: SUBSCRIBE_REALTIME_DATA,
      payload: {
        result,
        id,
      },
    });
  };
}

function fetchStatChartData(params, id) {
  return function(dispatch) {
    dispatch(setFetching(true, id));
    TimeAndSaleService.getStatChartData(params).then(res => {
      const { items = [] } = res;
      dispatch({
        type: FETCH_DATA_STAT_CHART,
        payload: {
          data: {
            [params.TimeRange]: items,
          },
          id,
        },
      });
      dispatch(setFetching(false, id));
    });
  };
}

function fetchInfoTicker(id, defaultCode = '') {
  return (dispatch, getState) => {
    const code =
      defaultCode ||
      getState()[REDUCER_NAME].listMultiComponent[id].condition.code;

    priceDataService.getLatestPrice({ Code: code }).then(response => {
      const { items = [] } = response;
      dispatch({
        type: GET_TOP_CONTENT,
        payload: {
          topContent: items && items.length ? items[0] : {},
          id,
        },
      });
    });
  };
}

function changeCode(data, id, isFetchData = true) {
  return dispatch => {
    const payload = {
      currentSearch: data,
      id,
    };

    dispatch({
      type: CHANGE_CODE,
      payload,
    });

    if (isFetchData) {
      dispatch(fetchDataTimeAndSale({ Code: data.code }, id));
      dispatch(fetchInfoTicker(id));
      dispatch({
        type: RESET_REALTIME_DATA,
        payload: {
          id,
        },
      });
    }
  };
}

function fetchDataTimeAndSale(params, id) {
  const formattedParams = formatedParams(params);
  return dispatch => {
    dispatch(setFetching(true, id));
    const resolver = response => response.items || [];
    const promises = [];
    promises.push(
      TimeAndSaleService.getTimeAndSale(formattedParams).then(resolver),
    );
    promises.push(
      TimeAndSaleService.getBuSdChart(formattedParams).then(resolver),
    );
    Promise.all(promises).then(([timeAndSaleData, busdData]) => {
      dispatch({
        type: FETCH_DATA_TIME_AND_SALE,
        payload: {
          busdData,
          timeAndSaleData:
            timeAndSaleData && timeAndSaleData.length ? timeAndSaleData[0] : {},
          id,
        },
      });
      dispatch(setFetching(false, id));
    });
  };
}

function formatedParams(params) {
  const { Code } = params;
  return {
    Code: Code || ConstCommon.searchBox.organCode,
  };
}

const initialState = {
  listMultiComponent: {},
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const { dragCode, id: dataId } = action.payload;

      return {
        ...state,
        ...initialState,
        listMultiComponent: {
          ...(state.listMultiComponent || {}),
          [dataId]: {
            timeAndSaleData: {},
            busdData: [],
            condition: dragCode
              ? {
                  code: dragCode.code,
                  displayCode: dragCode.displayCode,
                  isDerivatives: dragCode.isDerivatives,
                }
              : currentState.get(
                  ConstCommon.listComponent.TimeAndSales,
                  'currentSearch',
                  dataId,
                ) ||
                getSyncDefaultSearch(
                  ConstCommon.listComponent.TimeAndSales,
                ) || {
                  displayCode: ConstCommon.searchBox.organCode,
                  code: ConstCommon.searchBox.organCode,
                  isDerivatives: false,
                },
            topContent: {},
            topContentRealTime: {},
            isFetching: false,
            statData: {},
          },
        },
      };

    case UNMOUNT_COMPONENT:
      const delId = action.payload.id;
      const cloneListComponent = { ...state.listMultiComponent };
      const { [delId]: _, ...withoutDeleteKey } = cloneListComponent;
      if (Object.keys(withoutDeleteKey).length === 0) {
        return {};
      }
      return {
        ...state,
        listMultiComponent: withoutDeleteKey,
      };

    case FETCH_DATA_TIME_AND_SALE:
      const { timeAndSaleData, id, busdData } = action.payload;
      if (!state.listMultiComponent || !state.listMultiComponent[id]) {
        return state;
      }
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [id]: {
            ...state.listMultiComponent[id],
            timeAndSaleData,
            busdData,
          },
        },
      };
    case FETCH_DATA_STAT_CHART:
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [action.payload.id]: {
            ...state.listMultiComponent[action.payload.id],
            statData: {
              ...state.listMultiComponent[action.payload.id].statData,
              ...action.payload.data,
            },
          },
        },
      };

    case FETCH_BUSD_SUCCESS:
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [action.payload.componentId]: {
            ...state.listMultiComponent[action.payload.componentId],
            busdData: action.payload.data,
          },
        },
      };

    case CHANGE_SIZE_COMPONENT: {
      const { id: componentId } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            component: action.payload,
          },
        },
      };
    }

    case CHANGE_CODE:
      const { currentSearch, id: componentId } = action.payload;

      const { isDerivatives, code, displayCode } = currentSearch;

      currentState.add(
        ConstCommon.listComponent.TimeAndSales,
        'currentSearch',
        { isDerivatives, code, displayCode },
        componentId,
      );

      if (!('isDerivatives' in currentSearch)) {
        currentSearch.isDerivatives = false;
      }

      const listMultiComponent = {
        ...state.listMultiComponent,
        [componentId]: {
          ...state.listMultiComponent[componentId],
          condition: {
            ...state.listMultiComponent[componentId].condition,
            ...currentSearch,
          },
        },
      };

      return {
        ...state,
        listMultiComponent,
      };

    case GET_TOP_CONTENT:
      const {
        topContent: { bidAskInfo, priceInfo },
        id: compoId,
      } = action.payload;
      const Best1Bid = bidAskInfo ? bidAskInfo.best1Bid : null;
      const Best1Offer = bidAskInfo ? bidAskInfo.best1Offer : null;
      const Best1BidVolume = bidAskInfo ? bidAskInfo.best1BidVolume : null;
      const Best1OfferVolume = bidAskInfo ? bidAskInfo.best1OfferVolume : null;

      const OpenPrice = priceInfo ? priceInfo.openPrice : null;
      const HighestPrice = priceInfo ? priceInfo.highestPrice : null;
      const LowestPrice = priceInfo ? priceInfo.lowestPrice : null;
      const MatchPrice = priceInfo ? priceInfo.matchPrice : null;
      const PriceChange = priceInfo ? priceInfo.priceChange : null;

      const PercentPriceChange = priceInfo
        ? priceInfo.percentPriceChange
        : null;
      const ReferencePrice = priceInfo ? priceInfo.referencePrice : null;

      const CeilingPrice = priceInfo ? priceInfo.ceilingPrice : null;
      const FloorPrice = priceInfo ? priceInfo.floorPrice : null;
      const TotalMatchVolume = priceInfo ? priceInfo.totalMatchVolume : null;

      const topContent = {
        Bid: Best1Bid,
        Ask: Best1Offer,
        Best1BidVolume,
        Best1OfferVolume,
        OpenPrice,
        HighestPrice,
        LowestPrice,
        MatchPrice,
        PriceChange,
        PercentPriceChange,
        ReferencePrice,
        CeilingPrice,
        FloorPrice,
        TotalMatchVolume,
        comGroupCode: priceInfo ? priceInfo.comGroupCode : null,
        marketStatus: priceInfo ? priceInfo.marketStatus : null,
        ...bidAskInfo,
      };
      if (!state.listMultiComponent || !state.listMultiComponent[compoId]) {
        return state;
      }
      const cloneListMultiComponent = {
        ...state.listMultiComponent,
        [compoId]: {
          ...state.listMultiComponent[compoId],
          topContent,
        },
      };
      return {
        ...state,
        listMultiComponent: cloneListMultiComponent,
      };

    case SUBSCRIBE_REALTIME_DATA:
      const { result: resultTick, id: updateTickId } = action.payload;
      if (resultTick) {
        const {
          openPrice: OpenPrice,
          highestPrice: HighestPrice,
          lowestPrice: LowestPrice,
          matchPrice: MatchPrice,
          priceChange: PriceChange,
          percentPriceChange: PercentPriceChange,
          referencePrice: ReferencePrice,
          tradingDate: TradingDate,
          best1Bid: Best1Bid,
          best1Offer: Best1Offer,
          priceChange,
          matchVolume,
          matchType,
          ceilingPrice: CeilingPrice,
          floorPrice: FloorPrice,
          marketStatus,
          totalMatchVolume: TotalMatchVolume,
        } = resultTick;

        const newRowToTable = { ...resultTick };

        if (matchType === 1) {
          newRowToTable.matchType = 'BU';
        } else if (matchType === 2) {
          newRowToTable.matchType = 'SD';
        } else {
          newRowToTable.matchType = 'NA';
        }
        // fake matchType for data

        const simpleChartData = {
          buyUpVolume: 0,
          naVolume: 0,
          price: MatchPrice,
          sellDownVolume: 0,
        };

        // check data realtime
        // if matchPrice exist in list , combine them
        // else push data to list

        const optionalProps = {};

        if (priceChange > 0) {
          optionalProps.buyUpVolume = matchVolume;
        }

        if (priceChange < 0) {
          optionalProps.sellDownVolume = matchVolume;
        }

        if (priceChange === 0) {
          optionalProps.naVolume = matchVolume;
        }

        const newBarToChart = {
          ...simpleChartData,
          ...optionalProps,
        };
        if (
          !state.listMultiComponent[updateTickId].timeAndSaleData.timeAndSales
        ) {
          return state;
        }

        const dataBarChart = [
          ...state.listMultiComponent[updateTickId].timeAndSaleData
            .timeAndSales,
        ];

        let newDataBarChart = [];
        const currentPrice = dataBarChart.find(
          price => price.price === MatchPrice,
        );
        if (currentPrice) {
          const combineArr = [currentPrice, newBarToChart];
          const totalBU = combineArr.reduce((item1, item2) => {
            return item1 + item2.buyUpVolume;
          }, 0);

          const totalSD = combineArr.reduce((item1, item2) => {
            return item1 + item2.sellDownVolume;
          }, 0);

          const totalNA = combineArr.reduce((item1, item2) => {
            return item1 + item2.naVolume;
          }, 0);

          const currentPriceIndex = dataBarChart.findIndex(
            price => price.price === MatchPrice,
          );
          newDataBarChart = [
            ...dataBarChart.slice(0, currentPriceIndex),
            {
              buyUpVolume: totalBU,
              naVolume: totalNA,
              price: MatchPrice,
              sellDownVolume: totalSD,
            },
            ...dataBarChart.slice(currentPriceIndex + 1),
          ];
        } else {
          newDataBarChart = [...[newBarToChart], ...dataBarChart];
        }

        const topContentRealTime = {
          TotalMatchVolume,
          OpenPrice,
          HighestPrice,
          LowestPrice,
          MatchPrice,
          PriceChange,
          PercentPriceChange,
          ReferencePrice,
          Bid: Best1Bid,
          Ask: Best1Offer,
          TradingDate,
          CeilingPrice,
          FloorPrice,
          marketStatus,
        };
        const prevTotalMatchVolume =
          state.listMultiComponent[updateTickId].topContentRealTime
            .TotalMatchVolume ||
          state.listMultiComponent[updateTickId].topContent.TotalMatchVolume;
        const isAppendRow = TotalMatchVolume > prevTotalMatchVolume;
        const updateRealtimeTick = {
          ...state.listMultiComponent,
          [updateTickId]: {
            ...state.listMultiComponent[updateTickId],
            topContentRealTime,
            timeAndSaleData: {
              ...state.listMultiComponent[updateTickId].timeAndSaleData,
              matches: [
                ...(isAppendRow ? [newRowToTable] : []),
                ...state.listMultiComponent[updateTickId].timeAndSaleData
                  .matches,
              ],
              timeAndSales: newDataBarChart,
            },
          },
        };

        return {
          ...state,
          listMultiComponent: updateRealtimeTick,
        };
      }

      return {
        ...state,
      };

    case RESET_REALTIME_DATA:
      const resetId = action.payload.id;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [resetId]: {
            ...state.listMultiComponent[resetId],
            topContentRealTime: {},
          },
        },
      };

    case SET_FETCHING:
      const { id: fetchingId, status } = action.payload;
      if (!state.listMultiComponent || !state.listMultiComponent[fetchingId]) {
        return state;
      }
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [fetchingId]: {
            ...state.listMultiComponent[fetchingId],
            isFetching: status,
          },
        },
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
